import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firebase/config";

function refDividas(uid) {
  return collection(db, "usuarios", uid, "dividas");
}

export function ouvirDividas(uid, callback) {
  if (!uid) return () => {};

  const q = query(refDividas(uid), orderBy("criadoEm", "desc"));

  return onSnapshot(q, (snapshot) => {
    const lista = snapshot.docs.map((docSnap) => ({
      id: docSnap.id,
      ...docSnap.data(),
    }));

    callback(lista);
  });
}

export async function salvarDivida(uid, dados) {
  if (!uid) throw new Error("Usuário não encontrado.");

  const valorTotal = Number(dados.valorTotal || 0);
  const valorPago = Number(dados.valorPago || 0);
  const parcelas = Number(dados.parcelas || 1);
  const parcelaAtual = Number(dados.parcelaAtual || 0);
  const valorParcela = Number(dados.valorParcela || 0);

  await addDoc(refDividas(uid), {
    nome: dados.nome || "",
    categoria: dados.categoria || "Dívida",
    valorTotal,
    valorPago,
    valorRestante: Math.max(valorTotal - valorPago, 0),
    parcelas,
    parcelaAtual,
    valorParcela,
    vencimento: dados.vencimento || "",
    observacao: dados.observacao || "",
    status: valorTotal - valorPago <= 0 ? "quitada" : "em_dia",
    criadoEm: serverTimestamp(),
    atualizadoEm: serverTimestamp(),
  });
}

export async function marcarParcelaPaga(uid, divida) {
  if (!uid || !divida?.id) throw new Error("Dívida inválida.");

  const novaParcelaAtual = Number(divida.parcelaAtual || 0) + 1;
  const novoValorPago =
    Number(divida.valorPago || 0) + Number(divida.valorParcela || 0);

  const novoValorRestante = Math.max(
    Number(divida.valorTotal || 0) - novoValorPago,
    0
  );

  const status =
    novoValorRestante <= 0 || novaParcelaAtual >= Number(divida.parcelas || 1)
      ? "quitada"
      : "em_dia";

  const ref = doc(db, "usuarios", uid, "dividas", divida.id);

  await updateDoc(ref, {
    parcelaAtual: novaParcelaAtual,
    valorPago: novoValorPago,
    valorRestante: novoValorRestante,
    status,
    atualizadoEm: serverTimestamp(),
  });
}

export async function excluirDivida(uid, id) {
  if (!uid || !id) throw new Error("Dívida inválida.");

  const ref = doc(db, "usuarios", uid, "dividas", id);
  await deleteDoc(ref);
}
